// extracted by mini-css-extract-plugin
export default {"layout":"AuthLayout_layout__c6WVi"};